import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { TenantUtilities } from "@core/utilities";
import { TokenService } from "@auth/token.service";

export function authenticatedUserGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const tokenService: TokenService = inject(TokenService);
    
    const authResponse = tokenService.authResponse();
    if (!authResponse) {
      // User is not authenticated, redirect to login page
      const tenantId = TenantUtilities.getTenantFromRoute() || TenantUtilities.default_tenant;
      
      // Determine which login page to redirect to based on current route
      const isAdminRoute = state.url.includes('/admin');
      const loginPath = isAdminRoute ? 'admin/login' : 'kiosk/login';
      const loginUrl: UrlTree = router.parseUrl(`/${tenantId}/${loginPath}`);
      return loginUrl;
    }
    
    // User is authenticated, allow access
    return true;
  };
}
